import { FormControl, FormGroup } from '@angular/forms';
import { AddressFormModel } from './address-form.model';
import { Adres, AdresDomowy, AdresZagraniczny } from '../../../../models/adres';
import { DomesticAddressFormBuilder } from '../../form-domestic-address/form-group/domestic-address.form.builder';
import { ForeignAddressFormBuilder } from '../../form-foreign-address/form-group/foreign-address.form.builder';

export class AddressFormBuilder {
  public static createFormGroup(address?: Adres): FormGroup<AddressFormModel> {
    return new FormGroup<AddressFormModel>({
      czyAdresZagraniczny: new FormControl(
        address?.czyAdresZagraniczny || false,
      ),
      adres: DomesticAddressFormBuilder.createFormGroup(
        address?.adres || undefined,
      ),
      adresZagraniczny: ForeignAddressFormBuilder.createFormGroup(
        address?.adresZagraniczny || undefined,
      ),
    });
  }

  public static switchDomesticOrForeignGroup(
    fg: FormGroup<AddressFormModel>,
    init?: boolean,
  ): void {
    if (fg.controls.czyAdresZagraniczny.value === true) {
      fg.controls.adres.reset();
      fg.controls.adres.disable();
      if (!init) {
        fg.controls.adresZagraniczny.enable();
      }
    } else {
      fg.controls.adresZagraniczny.disable();
      fg.controls.adresZagraniczny.reset();
      if (!init) {
        fg.controls.adres.enable();
      }
    }
  }

  public static mapAdres(
    fg: FormGroup<AddressFormModel>,
    mapAdresKorespondencyjny?: boolean,
    czyAdresKorespondencyjny?: boolean,
  ): Adres | null {
    const adres = new Adres();

    if (mapAdresKorespondencyjny && !czyAdresKorespondencyjny) {
      return null;
    }

    if (fg.controls.czyAdresZagraniczny.value) {
      adres.czyAdresZagraniczny = true;
      adres.adresZagraniczny = this.mapAdresZagraniczny(fg);
    } else {
      adres.czyAdresZagraniczny = false;
      adres.adres = this.mapAdresDomowy(fg);
    }
    return adres;
  }

  private static mapAdresZagraniczny(
    fg: FormGroup<AddressFormModel>,
  ): AdresZagraniczny {
    let adresZagraniczny = new AdresZagraniczny();
    adresZagraniczny.gminaDzielnica =
      fg.controls.adresZagraniczny.controls.gminaDzielnica.value;
    adresZagraniczny.miejscowosc =
      fg.controls.adresZagraniczny.controls.miejscowosc.value;
    adresZagraniczny.ulica = fg.controls.adresZagraniczny.controls.ulica.value;
    adresZagraniczny.kodPocztowyZagraniczny =
      fg.controls.adresZagraniczny.controls.kodPocztowyZagraniczny.value;
    adresZagraniczny.nrDomu =
      fg.controls.adresZagraniczny.controls.nrDomu.value;
    adresZagraniczny.nrLokalu =
      fg.controls.adresZagraniczny.controls.nrLokalu.value;
    adresZagraniczny.panstwo =
      fg.controls.adresZagraniczny.controls.panstwo.value;
    return adresZagraniczny;
  }

  private static mapAdresDomowy(fg: FormGroup<AddressFormModel>): AdresDomowy {
    let adresDomowy = new AdresDomowy();
    adresDomowy.gminaDzielnica =
      fg.controls.adres.controls.gminaDzielnica.value;
    adresDomowy.miejscowosc = fg.controls.adres.controls.miejscowosc.value;
    adresDomowy.ulica = fg.controls.adres.controls.ulica.value;
    adresDomowy.kodPocztowy = fg.controls.adres.controls.kodPocztowy.value;
    adresDomowy.poczta = fg.controls.adres.controls.poczta.value;
    adresDomowy.nrDomu = fg.controls.adres.controls.nrDomu.value;
    adresDomowy.nrLokalu = fg.controls.adres.controls.nrLokalu.value;
    return adresDomowy;
  }
}
